var map = {
	"./cardicon.webp": 1100,
	"./casino.webp": 1099,
	"./cricket.webp": 1118,
	"./election-old.webp": 1159,
	"./election.webp": 1160,
	"./greyhound-racing.webp": 1161,
	"./greyhound.webp": 1070,
	"./horse.webp": 1162,
	"./lottery.webp": 1163,
	"./raceicon.webp": 1164,
	"./sloticon.webp": 1101,
	"./soccer.webp": 1165,
	"./tennis.webp": 1166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1096;